import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export interface SiteStatus {
  enabled: boolean;
}

export const getSiteStatus = async (): Promise<boolean> => {
  try {
    const response = await axios.get(`${API_URL}/site/status`, {
      headers: {
        "Content-Type": "application/json",
      },
      validateStatus: () => true,
    });

    // console.log("getSiteStatus response:", response);

    if (response.status === 200 && response.data) {
      return response.data.enabled;
    } else {
      console.error("Erreur lors de la récupération du statut du site:", response.status, response.data);
      return true;
    }
  } catch (error: any) {
    console.error("Erreur dans getSiteStatus:", error);
    return true;
  }
};

export const setSiteStatus = async (enabled: boolean): Promise<boolean> => {
  try {
    const tokenRaw = localStorage.getItem("token");

    // console.log("Token raw:", tokenRaw);

    if (!tokenRaw) {
      console.warn("Token manquant pour mettre à jour le statut du site");
      return false;
    }

    const token = tokenRaw.replace(/"/g, '');

    const response = await axios.put(`${API_URL}/site/update-status`, { enabled }, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      validateStatus: () => true,
    });

    // console.log("setSiteStatus response:", response);

    if (response.status === 200) {
      return true;
    } else {
      console.error("Erreur lors de la mise à jour du statut du site:", response.status, response.data);
      return false;
    }
  } catch (error: any) {
    console.error("Erreur dans setSiteStatus:", error);
    return false;
  }
};
